import React from 'react';

import './style.css';

const HighlightInk = ({ children, ...otherProps }) => {
  return (
    <span className="highlight-ink" {...otherProps}>
      {children}
    </span>
  );
};

export default HighlightInk;



// WEBPACK FOOTER //
// ./src/Components/HighlightInk/index.js